export default {"src":"/_next/static/media/courses-1.192513cc.svg","height":96,"width":242,"blurWidth":0,"blurHeight":0};